import React, {Component} from 'react';
import {InputNumber} from 'antd';
import './SAInputNumber.css';
import {injectIntl} from 'react-intl';
import FieldError from './FieldError';

class SAInputNumber extends Component {
  render() {
    const {
      error,
      className,
      name,
      onChange,
      placeholder,
      value,
      min,
      max,
      ...attributes
    } = this.props;

    const errorClassName = error ? ' error' : '';

    return (
      <span className={className + errorClassName}>
        <InputNumber
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          min={min}
          max={max}
          {...attributes}
        />
        {error && <FieldError error={error} />}
      </span>
    );
  }
}

export default injectIntl(SAInputNumber);



// WEBPACK FOOTER //
// ./src/components/common/input/SAInputNumber.js